// ============================================================
// THE RAYHAN KONSERT — SYUKUR 26
// Kandungan laman. SEMUA maklumat di bawah diambil terus
// daripada poster rasmi konsert. Jangan tambah maklumat yang
// tidak ada pada poster atau tidak disahkan penganjur.
// ============================================================

// Tarikh & masa konsert (sasaran countdown)
export const EVENT_DATETIME_ISO = "2026-10-31T20:45:00+08:00";

export const EVENT = {
  brand: "THE RAYHAN KONSERT",
  title: "SYUKUR 26",
  tagline: "Simfoni Merentas Zaman",
  taglineUpper: "SIMFONI MERENTAS ZAMAN",
  day: "Sabtu",
  dateLong: "31 Oktober 2026",
  dateWithDay: "Sabtu, 31 Oktober 2026",
  dateShort: "31 OKT 2026",
  dateUpper: "31 OKTOBER 2026",
  time: "8.45 Malam",
  timeEnd: "11.30 Malam",
  timeRange: "8.45 \u2013 11.30 Malam",
  venue: "Megastar Arena",
  venueFull: "Megastar Arena Kuala Lumpur",
  venueUpper: "MEGASTAR ARENA KUALA LUMPUR",
  location: "Kuala Lumpur",
  social: "@therayhankonsert",
};

// Platform tiket rasmi
export const TICKET_URL = "https://rayhan.ubertickets.asia/events/169353";
export const TICKET_DOMAIN = "rayhan.ubertickets.asia";

// Pautan & hubungan rasmi (dari laman tiket rasmi Übertickets)
export const OFFICIAL = {
  terms: "https://rayhan.ubertickets.asia/terms",
  faq: "https://rayhan.ubertickets.asia/faq",
  email: "contact@ubertickets.my",
  whatsapp: "+60 19-588 1810",
  whatsappUrl:
    "https://wa.me/60195881810?text=Saya%20ingin%20bertanya%20tentang%20The%20Rayhan",
  organiserLegal: "Bintang Batu Event (202403032036)",
  organiserAddress:
    "31-1, Jln Opera F U2/F, TTDI Jaya, 40150 Shah Alam, Selangor",
};

// Poster rasmi
export const POSTERS = [
  {
    id: "utama",
    label: "Poster Rasmi",
    caption:
      "The Rayhan Konsert: Syukur 26. Simfoni Merentas Zaman. 31 Oktober 2026, 8.45 malam, Megastar Arena Kuala Lumpur.",
    src: "/posters/poster-utama.jpg",
    srcWebp: "/posters/poster-utama.webp",
    view: "/posters/poster-utama-lg.jpg",
    viewWebp: "/posters/poster-utama-lg.webp",
    thumb: "/posters/poster-utama-sm.jpg",
    thumbWebp: "/posters/poster-utama-sm.webp",
    tiny: "/posters/poster-utama-xs.jpg",
    tinyWebp: "/posters/poster-utama-xs.webp",
    alt: "Poster rasmi The Rayhan Konsert Syukur 26",
  },
  {
    id: "pelan",
    label: "Pelan Tempat Duduk",
    caption:
      "Pelan tempat duduk dan harga bagi setiap kategori. Semua kategori adalah tempat duduk.",
    src: "/posters/poster-pelan-tempat-duduk.jpg",
    srcWebp: "/posters/poster-pelan-tempat-duduk.webp",
    view: "/posters/poster-pelan-tempat-duduk-lg.jpg",
    viewWebp: "/posters/poster-pelan-tempat-duduk-lg.webp",
    thumb: "/posters/poster-pelan-tempat-duduk-sm.jpg",
    thumbWebp: "/posters/poster-pelan-tempat-duduk-sm.webp",
    tiny: "/posters/poster-pelan-tempat-duduk-xs.jpg",
    tinyWebp: "/posters/poster-pelan-tempat-duduk-xs.webp",
    alt: "Pelan tempat duduk dan harga tiket Syukur 26",
  },
  {
    id: "pakej",
    label: "Pakej & Merchandise",
    caption:
      "Kandungan pakej bagi setiap kategori tiket berserta merchandise konsert.",
    src: "/posters/poster-pakej-tiket.jpg",
    srcWebp: "/posters/poster-pakej-tiket.webp",
    view: "/posters/poster-pakej-tiket-lg.jpg",
    viewWebp: "/posters/poster-pakej-tiket-lg.webp",
    thumb: "/posters/poster-pakej-tiket-sm.jpg",
    thumbWebp: "/posters/poster-pakej-tiket-sm.webp",
    tiny: "/posters/poster-pakej-tiket-xs.jpg",
    tinyWebp: "/posters/poster-pakej-tiket-xs.webp",
    alt: "Pakej tiket dan merchandise Syukur 26",
  },
];

export const POSTER_UTAMA = POSTERS[0];
export const POSTER_PELAN = POSTERS[1];
export const POSTER_PAKEJ = POSTERS[2];

// Harga rasmi (normal price) seperti poster.
export const TICKET_TIERS = [
  {
    id: "super-vip",
    name: "Super VIP",
    price: 1288,
    color: "#4a9fdc",
    perks: [
      "Meet & Greet",
      "Lanyard + Pass",
      "Poster + Kipas",
      "T-Shirt Exclusive",
      "Woven Bag",
      "Wristband",
    ],
  },
  {
    id: "vip",
    name: "VIP",
    price: 559,
    color: "#2340a8",
    perks: ["Lanyard + Pass", "Poster + Kipas", "Woven Bag", "Wristband"],
  },
  {
    id: "platinum",
    name: "Platinum",
    price: 469,
    color: "#0e8a3c",
    perks: ["Lanyard + Pass", "Poster + Kipas", "Wristband"],
  },
  {
    id: "gold",
    name: "Gold",
    price: 389,
    color: "#dcd83a",
    perks: ["Wristband"],
  },
  {
    id: "silver",
    name: "Silver",
    price: 329,
    color: "#6b5030",
    perks: ["Wristband"],
  },
  {
    id: "bronze",
    name: "Bronze",
    price: 279,
    color: "#e4544a",
    perks: ["Wristband"],
  },
];

// Susunan zon dari pentas ke belakang, ikut pelan rasmi.
export const SEAT_ORDER = [
  { id: "stage", label: "STAGE", color: "#2b2b2b", width: 62, textLight: true },
  { id: "vip", label: "VIP", color: "#2340a8", width: 52, textLight: true },
  { id: "platinum", label: "PLATINUM", color: "#0e8a3c", width: 66, textLight: true },
  { id: "gold", label: "GOLD", color: "#dcd83a", width: 78, textLight: false },
  { id: "foh", label: "FOH", color: "#2b2b2b", width: 34, textLight: true },
  { id: "super-vip", label: "SUPER VIP", color: "#1f8ed6", width: 86, textLight: true },
  { id: "silver", label: "SILVER", color: "#6b5030", width: 92, textLight: true },
  { id: "bronze", label: "BRONZE", color: "#e4544a", width: 100, textLight: true },
];

export const PARTNERS = [
  { role: "Penganjur", names: ["Bintang Batu Event", "Magnificent Event"] },
  {
    role: "Rakan Strategik",
    names: ["Havoc Event & Management", "Top G Coffee & Cafe"],
  },
  { role: "Merchandise Partner", names: ["HVC"] },
  { role: "Tiket Rasmi", names: ["Übertickets"] },
];

// FAQ: hanya soalan yang boleh dijawab daripada poster rasmi.
export const FAQS = [
  {
    q: "Bila dan di mana konsert ini berlangsung?",
    a: "Sabtu, 31 Oktober 2026, 8.45 malam hingga 11.30 malam, di Megastar Arena Kuala Lumpur.",
  },
  {
    q: "Di mana saya boleh beli tiket?",
    a: "Tiket rasmi dijual di rayhan.ubertickets.asia. Klik mana-mana butang Beli Tiket di laman ini untuk terus ke platform rasmi.",
  },
  {
    q: "Berapa harga tiket bagi setiap kategori?",
    a: "Super VIP RM1288, VIP RM559, Platinum RM469, Gold RM389, Silver RM329 dan Bronze RM279.",
  },
  {
    q: "Adakah semua kategori mempunyai tempat duduk?",
    a: "Ya. Menurut poster rasmi, semua kategori adalah tempat duduk (all categories are seated).",
  },
  {
    q: "Apa yang termasuk dalam setiap pakej tiket?",
    a: "Super VIP: Meet & Greet, Lanyard + Pass, Poster + Kipas, T-Shirt Exclusive, Woven Bag, Wristband. VIP: Lanyard + Pass, Poster + Kipas, Woven Bag, Wristband. Platinum: Lanyard + Pass, Poster + Kipas, Wristband. Gold, Silver dan Bronze: Wristband.",
  },
  {
    q: "Adakah ada caj tambahan selain harga tiket?",
    a: "Harga di laman ini adalah harga tiket seperti poster rasmi. Sebarang caj platform atau caj perkhidmatan akan dipaparkan semasa pembayaran di Übertickets. Sila rujuk Terma & Syarat rasmi di rayhan.ubertickets.asia/terms.",
  },
  {
    q: "Bagaimana saya boleh hubungi khidmat pelanggan?",
    a: "Übertickets menguruskan semua tiket rasmi. E-mel: contact@ubertickets.my atau WhatsApp +60 19-588 1810. Penganjur: Bintang Batu Event (202403032036), 31-1, Jln Opera F U2/F, TTDI Jaya, 40150 Shah Alam, Selangor.",
  },
  {
    q: "Siapa penganjur konsert ini?",
    a: "Penganjur: Bintang Batu Event dan Magnificent Event. Rakan strategik: Havoc Event & Management dan Top G Coffee & Cafe. Merchandise partner: HVC. Tiket rasmi: Übertickets.",
  },
  {
    q: "Di mana saya boleh dapatkan pengumuman terkini?",
    a: "Ikuti akaun TikTok rasmi @therayhankonsert untuk pengumuman terkini daripada penganjur.",
  },
];
